module.exports = __webpack_public_path__ + "img/bath-room.2b498626.svg";